import { type FunctionComponent, type PropsWithChildren, createContext, useState } from 'react';
import { AnalyticsHelper } from '../../helpers/analytics/analytics.helper';
import { buildProductQuantityChange } from '../../helpers/analytics/gtm/product-event-builders';
import { updateSelectionTotal } from '../../helpers/product-helper/configuration/product-configuration.helper';
import { type Selection } from '../../types/product-option.types';

type AddToCartContextState = {
	selection?: Selection;
	setSelection: (selection?: Selection) => void;
	setCartQuantity: (cartQuantity?: number) => void;
};

const initialState: AddToCartContextState = {
	selection: undefined,
	setSelection: () => {},
	setCartQuantity: () => {}
};
// TODO: clean up old experience SODEV-40175 this file needs to go away
export const AddToCartContext = createContext<AddToCartContextState>(initialState);

export const AddToCartContextProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
	const [selection, setSelectionState] = useState<Selection | undefined>(initialState.selection);

	const setSelection = (newSelection?: Selection) => {
		setSelectionState((prevSelection) => {
			const prevQuantity = prevSelection?.quantity || 1;
			return newSelection
				? updateSelectionTotal({
						...newSelection,
						quantity: prevQuantity,
						initialTotal: prevQuantity * newSelection.price
				  })
				: newSelection;
		});
	};

	const setCartQuantity = (newQuantity?: number) => {
		void AnalyticsHelper.track(buildProductQuantityChange(false));
		if (newQuantity === undefined) return;

		setSelectionState((prevSelection) => {
			return prevSelection
				? updateSelectionTotal({
						...prevSelection,
						quantity: newQuantity,
						initialTotal: newQuantity * prevSelection.price
				  })
				: prevSelection;
		});
	};

	const value: AddToCartContextState = { selection, setSelection, setCartQuantity };

	return <AddToCartContext.Provider value={value}>{children}</AddToCartContext.Provider>;
};
